import React from 'react'
import classNames from 'classnames'

import { Heading, Paragraph } from '@scentregroup/ui'

import ResponsiveImage from '../../responsive-image'
import style from './index.module.scss'

type Props = {
  className?: string
  image?: string
  title?: string
  body?: string
}

const JengaItem: React.FC<Props> = ({ className, image, title, body }) => (
  <div className={classNames(className, style['jenga-item'])}>
    {image ? (
      <ResponsiveImage
        desktopImageUrl={image}
        mobileImageUrl={image}
        desktopRatio="square"
        mobileRatio="square"
        alt=""
      />
    ) : (
      ''
    )}
    {title ? (
      <Heading type="extrasmall" className={classNames(style.title)}>
        {title}
      </Heading>
    ) : (
      ''
    )}
    {body ? (
      <Paragraph type="small" className={classNames(style.body)}>
        {body}
      </Paragraph>
    ) : (
      ''
    )}
  </div>
)

export default JengaItem
